import { render, staticRenderFns } from "./Recentevents.vue?vue&type=template&id=015539f0&scoped=true"
import script from "./Recentevents.vue?vue&type=script&lang=js"
export * from "./Recentevents.vue?vue&type=script&lang=js"
import style0 from "./Recentevents.vue?vue&type=style&index=0&id=015539f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015539f0",
  null
  
)

export default component.exports